import { UnexpectedError } from "../../../domain/errors/unexpected-error";
import {
  CityRuleCountPageModel,
  ServiceTaxationCodeAdmin,
  TaxationLayout,
  TaxationRuleCreateModel,
  TaxationRuleModel,
  TaxationRuleUpdateModel,
} from "../../../domain/models/service-taxation-code";
import { HttpClient, HttpStatusCode } from "../../protocols/http/http-client";

export class RemoteServiceTaxationCodeAdmin implements ServiceTaxationCodeAdmin {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient
  ) {}

  async searchCities(search: string, page = 0, size = 10): Promise<CityRuleCountPageModel> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/cities`,
      method: "get",
      params: { search, page, size },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async listCityRules(ibge: string, layout: TaxationLayout): Promise<TaxationRuleModel[]> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/cities/${ibge}/rules`,
      method: "get",
      params: { layout },
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async createCityRule(ibge: string, data: TaxationRuleCreateModel): Promise<TaxationRuleModel> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/cities/${ibge}/rules`,
      method: "post",
      body: data,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.created:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async updateRule(id: number, data: TaxationRuleUpdateModel): Promise<TaxationRuleModel> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/rules/${id}`,
      method: "put",
      body: data,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      default:
        throw new UnexpectedError();
    }
  }

  async deleteRule(id: number): Promise<void> {
    const httpResponse = await this.httpClient.request({
      url: `${this.url}/rules/${id}`,
      method: "delete",
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
      case HttpStatusCode.noContent:
        return;
      default:
        throw new UnexpectedError();
    }
  }
}
